import { ControllerAdditionalInfo } from 'src/types/controllers/controller';
import { PREDEFINED, RANGE } from '../components/ControllerModalContent/config';
import { ActiveModeType } from '../types';
import { filterData, getModeDisplayLabel } from '../utils';

type UseActiveModeTypes = {
  activeMode?: ActiveModeType;
  controllerAdditionalInfo?: ControllerAdditionalInfo[];
};

export const useActiveMode = ({ activeMode, controllerAdditionalInfo }: UseActiveModeTypes) => {
  const activeModeTagId = activeMode?.tagId;
  const activeModeValue = activeMode?.value;
  const activeModeName = activeMode?.name;

  let displayMode = '';

  const filteredModeTags = filterData(controllerAdditionalInfo, 'mode');

  const isMultipleModeTags = filteredModeTags?.length > 1;
  const findControlleAdditionalInfo = controllerAdditionalInfo?.find(
    (item) => item.id === activeModeTagId
  );

  const allowedInputs = findControlleAdditionalInfo?.advancedTagMapping?.allowedInputs;

  if (!isMultipleModeTags && allowedInputs === PREDEFINED) {
    displayMode = `${activeModeValue}-${activeModeName}`;
  }
  if (!isMultipleModeTags && allowedInputs === RANGE) {
    displayMode = `${activeModeValue}`;
  }
  if (isMultipleModeTags && allowedInputs === PREDEFINED) {
    displayMode = `${findControlleAdditionalInfo?.displayName}-${activeModeValue}-${activeModeName}`;
  }
  if (isMultipleModeTags && allowedInputs === RANGE) {
    displayMode = `${findControlleAdditionalInfo?.displayName}-${activeModeValue}`;
  }

  const displayModeLabel =
    allowedInputs === PREDEFINED
      ? getModeDisplayLabel({
          value: activeModeValue,
          name: activeModeName,
          fallbackValue: findControlleAdditionalInfo?.fallbackValue,
          tagDisplayName: isMultipleModeTags ? findControlleAdditionalInfo?.displayName : undefined,
          labellingType: findControlleAdditionalInfo?.labellingType,
          fallback: displayMode,
        })
      : displayMode;

  return {
    displayMode: displayMode,
    displayModeLabel: displayModeLabel,
  };
};
